import { useDispatch, useSelector } from 'react-redux';

// material-ui
// import { useTheme } from '@mui/material/styles';
import { AppBar, Box, CssBaseline, useMediaQuery, useTheme } from '@mui/material';

// project imports

import Header from './Header';
// import Sidebar from './Sidebar';
import Customization from '../Customization';
// import navigation from 'menu-items';
// import { drawerWidth } from 'store/constant';
import { SET_MENU } from 'store/actions';

// assets

import Footer from './Footer';
import useScrollPosition from 'hooks/useScrollPosition';
import Sidebar from './Sidebar';
// import { NAVBAR_HEIGHT } from 'constants';

// styles
// const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' && prop !== 'theme' })(({ theme, open }) => ({
//   ...theme.typography.mainContent,
//   borderBottomLeftRadius: 0,
//   borderBottomRightRadius: 0,
//   transition: theme.transitions.create(
//     'margin',
//     open
//       ? {
//           easing: theme.transitions.easing.easeOut,
//           duration: theme.transitions.duration.enteringScreen
//         }
//       : {
//           easing: theme.transitions.easing.sharp,
//           duration: theme.transitions.duration.leavingScreen
//         }
//   )
// }));

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = ({ children }) => {
  const theme = useTheme();
  const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
  // Handle left drawer
  const leftDrawerOpened = useSelector((state) => state.customization.opened);
  const dispatch = useDispatch();
  const handleLeftDrawerToggle = () => {
    dispatch({ type: SET_MENU, opened: !leftDrawerOpened });
  };
  const scrollPosition = useScrollPosition();

  return (
    <Box>
      <CssBaseline />
      {/* header */}
      <AppBar
        elevation={0}
        sx={{
          py: 2,
          pb: 2,
          // height: NAVBAR_HEIGHT,
          // bgcolor: scrollPosition > 10 ? 'rgba(7,7,16,.7)' : 'transparent',
          bgcolor: 'transparent',
          backdropFilter: scrollPosition > 10 && 'blur(60px)'
        }}
      >
        <Header handleLeftDrawerToggle={handleLeftDrawerToggle} />
      </AppBar>

      {/* drawer */}
      {matchDownMd && <Sidebar drawerOpen={!leftDrawerOpened} drawerToggle={handleLeftDrawerToggle} />}

      {/* main content */}
      <Box>{children}</Box>
      <Footer />
      <Customization />
    </Box>
  );
};

export default MainLayout;
